import { Paper, Tooltip, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export const InfoTooltip = (props) => (
  <Tooltip
    componentsProps={{ tooltip: { sx: { fontSize: '0.75rem' } } }}
    {...props}
  />
)

export const OutreachStatsCard = ({
  value,
  label,
  color,
  disabled,
  infoTooltip,
  caption,
  flex = 1,
  padding = 2,
}) => (
  <Paper
    elevation={1}
    sx={{
      p: padding,
      flex,
      textAlign: 'center',
      position: 'relative',
      opacity: disabled ? 0.4 : 1,
      '& .info-icon': { opacity: 0 },
      '&:hover .info-icon': { opacity: 1 },
    }}
  >
    {infoTooltip && (
      <InfoTooltip title={infoTooltip}>
        <InfoOutlinedIcon
          className="info-icon"
          sx={{
            fontSize: '16px !important',
            color: 'text.disabled',
            transition: 'opacity 0.15s',
            position: 'absolute',
            top: 6,
            right: 6,
          }}
        />
      </InfoTooltip>
    )}
    <Typography variant="h4" color={disabled ? 'text.disabled' : color}>
      {disabled ? '—' : value}
    </Typography>
    <Typography
      variant="caption"
      color={color ?? 'text.secondary'}
      sx={{
        display: 'block',
        visibility: caption && !disabled ? 'visible' : 'hidden',
      }}
    >
      {caption ?? '0%'}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Paper>
)
